import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <>
      <Seo title="Sayfa Bulunamadı | Ankara Düğün Fotoğrafçısı" description="Aradığınız sayfa bulunamadı." noindex path="/404" />
      <div className="min-h-screen grid place-items-center bg-[#0E0F10] text-center px-4">
        <div>
          <div className="font-display text-7xl text-[#D7B86A]">404</div>
          <h1 className="font-display text-3xl text-[#F7F2E8] mt-2">Sayfa bulunamadı</h1>
          <p className="text-[#9A9387] mt-3">Aradığınız sayfa taşınmış veya kaldırılmış olabilir.</p>
          <Link to="/" className="inline-block mt-6">
            <Button className="bg-[#C8A24A] text-[#141517] hover:bg-[#D7B86A] font-semibold">Anasayfaya Dön</Button>
          </Link>
        </div>
      </div>
    </>
  );
}
